import { useAuthEmail } from "@/stores/authStore";
import { isInternalStaffEmail, isNonProductionEnv } from "@/utils/env";

/**
 * Gates NON-PROD-only tooling (e.g. the dashboard scenario panel): visible only in
 * non-production environments AND to internal staff (@mindsea / @pointcare).
 * The email check matters in staging, which external users can also access.
 */
export const useIsDevToolsEnabled = (): boolean => {
  const authEmail = useAuthEmail();
  return isNonProductionEnv && isInternalStaffEmail(authEmail);
};
